if (!customElements.get('header-drawer')) {
  class HeaderDrawer extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.closeButtons = this.querySelectorAll('.menu-drawer__close-button');

      if (!this.details || !this.summary) return;

      this.summary.setAttribute('role', 'button');
      this.summary.setAttribute('aria-expanded', 'false');
      if (this.summary.nextElementSibling?.id) {
        this.summary.setAttribute('aria-controls', this.summary.nextElementSibling.id);
      }

      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      this.addEventListener('keyup', this.onKeyUp.bind(this));
      this.closeButtons.forEach((button) => button.addEventListener('click', this.closeSubmenu.bind(this)));
    }

    onSummaryClick(event) {
      event.preventDefault();
      if (this.details.hasAttribute('open')) {
        this.close();
      } else {
        this.open();
      }
    }

    onKeyUp(event) {
      if (event.code?.toUpperCase() !== 'ESCAPE') return;
      if (event.target.closest('details') !== this.details) return;
      this.close();
      this.summary.focus();
    }

    open() {
      const sectionHeader = document.querySelector('.section-header');
      const headerBottom = sectionHeader ? sectionHeader.getBoundingClientRect().bottom : this.getBoundingClientRect().bottom;

      document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerBottom, 10)}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      sectionHeader?.classList.add('menu-open');
      this.details.setAttribute('open', '');

      window.requestAnimationFrame(() => {
        this.details.classList.add('menu-opening');
      });

      this.summary.setAttribute('aria-expanded', 'true');
      document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint || 'tablet'}`);
    }

    close() {
      const sectionHeader = document.querySelector('.section-header');

      sectionHeader?.classList.remove('menu-open');
      this.details.classList.remove('menu-opening');
      this.summary.setAttribute('aria-expanded', 'false');
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint || 'tablet'}`);

      window.setTimeout(() => {
        if (!this.details.classList.contains('menu-opening')) {
          this.details.removeAttribute('open');
        }
      }, 400);
    }

    closeSubmenu(event) {
      const details = event.currentTarget.closest('details');
      if (!details || details === this.details) return;

      details.classList.remove('menu-opening');
      details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => details.removeAttribute('open'), 400);
    }
  }

  customElements.define('header-drawer', HeaderDrawer);
}

(() => {
  const sectionHeader = document.querySelector('.section-header');
  const headerWrapper = sectionHeader?.querySelector('.header-wrapper');

  if (!sectionHeader || !headerWrapper || headerWrapper.dataset.stickyType === 'none') return;

  let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;
  let ticking = false;

  function setHeaderHeight() {
    document.documentElement.style.setProperty('--header-height', `${sectionHeader.clientHeight}px`);
  }

  function updateHeader() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const stickyType = headerWrapper.dataset.stickyType;

    setHeaderHeight();

    if (sectionHeader.classList.contains('menu-open')) {
      sectionHeader.classList.remove('shopify-section-header-hidden');
      lastScrollTop = scrollTop;
      ticking = false;
      return;
    }

    if (stickyType === 'on-scroll-up') {
      if (scrollTop > lastScrollTop && scrollTop > sectionHeader.clientHeight) {
        sectionHeader.classList.add('shopify-section-header-hidden');
      } else {
        sectionHeader.classList.remove('shopify-section-header-hidden');
      }
    } else {
      sectionHeader.classList.remove('shopify-section-header-hidden');
    }

    lastScrollTop = Math.max(scrollTop, 0);
    ticking = false;
  }

  setHeaderHeight();
  window.addEventListener('resize', setHeaderHeight, { passive: true });
  window.addEventListener(
    'scroll',
    () => {
      if (!ticking) {
        window.requestAnimationFrame(updateHeader);
        ticking = true;
      }
    },
    { passive: true }
  );
})();
